
export const checkDateIsOld = (timestamp: number): boolean => {
  return timestamp * 1000 < Date.now();
};
